import { render, staticRenderFns } from "./BlogAdmin.vue?vue&type=template&id=24ff014f&scoped=true&"
import script from "./BlogAdmin.vue?vue&type=script&lang=js&"
export * from "./BlogAdmin.vue?vue&type=script&lang=js&"
import style0 from "./BlogAdmin.vue?vue&type=style&index=0&id=24ff014f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24ff014f",
  null
  
)

export default component.exports